import { api } from './client';

export interface CanvaStatus {
  connected: boolean;
  expiresAt?: string;
  templateId?: string;
}

export interface CanvaDesign {
  id: string;
  url: string;
  thumbnailUrl: string;
  title: string;
}

export async function getCanvaStatus(): Promise<CanvaStatus> {
  return api.get('/canva/status');
}

export async function getCanvaAuthUrl(): Promise<{ url: string }> {
  return api.get('/canva/auth-url');
}

export async function generateDesign(data: {
  session_id: string;
  problem_statement_id?: string;
  solution_idea_id?: string;
  headline: string;
  body_text: string;
}): Promise<CanvaDesign> {
  return api.post('/canva/generate', data);
}

export async function getDesign(designId: string): Promise<CanvaDesign> {
  return api.get(`/canva/design/${designId}`);
}
